export default "__VITE_ASSET__3EpWp7lG__"